import { axiosInstance } from './api';

/** Связи данных для «Статуса» (Алексей 28.10, #3189) — BE plugins/ops_tasks/api/data_links.py. */
export interface DataLinkDto {
  key: 'checklist_reviews' | 'layout_reviews' | 'speech_gaps';
  panel: 'checklists' | 'layout' | 'speech';
  title: string;
  note: string;
  n: number;
  of: number;
  items: Array<Record<string, unknown> & { day: string }>;
}

export const getDataLinks = (zoneId: string, days = 30) =>
  axiosInstance.get<{ links: DataLinkDto[]; date_from: string; date_to: string }>(`/ops_tasks/links/${zoneId}/`, { params: { days } });
